import { g as getRoomType } from './get-room-type.js';
import { t as translateDate } from './translate-date.js';
import './index2.js';

/*
 * Booking Sued Tirol
 */
const factory = function factory({ window, document, thn }) {
    let refreshPrice;
    const roomDetailsParseData = (numAdults, numChildren) => {
        const roomsArray = Array.from(document.querySelectorAll('.Bs-Room.Bs-Item')) ?? [];
        if (thn.empty(roomsArray)) {
            return [];
        }
        const roomsInfo = roomsArray
            .map((room) => {
            const roomName = room.querySelector('.Bs-Item__Title')?.textContent?.trim();
            if (!roomName) {
                return null;
            }
            const roomType = getRoomType(roomName);
            const ratesInfo = Array.from(room.querySelectorAll('.Bs-Rate'))
                ?.map((rate) => {
                const rateName = rate.querySelector('.Bs-InfoText__Title')?.textContent?.trim();
                const ratePrice = thn.parseNumber(rate.querySelector('.Bs-Rate__Price strong')?.textContent);
                const hasBreakfast = true;
                const isRefundable = true;
                if (!rateName || !ratePrice) {
                    return null;
                }
                const rateData = {
                    name: rateName,
                    totalNight: ratePrice,
                    breakfast: hasBreakfast,
                    refundable: isRefundable,
                };
                return rateData;
            })
                .filter((value) => value !== null);
            const roomData = {
                name: roomName,
                adults: numAdults || 2,
                children: numChildren || 0,
                type: roomType,
                prices: ratesInfo,
            };
            return roomData;
        });
        return roomsInfo.filter((value) => value !== null);
    };
    return {
        generateSearchUrl(ctx) {
            // https://www.hotelmignon.com/en/rooms/book?ref=ratechecker&lang=en&arrival=2025-05-12&departure=2025-05-14&guests=[[18,18],[18,18,7]]
            // https://www.hotelmignon.com/de/wohnen/buchen?ref=ratechecker&lang=de&arrival=2025-05-19&departure=2025-05-21&guests=[[18,18]]
            // https://www.hotelmignon.com/it/camere/prenotazione?ref=ratechecker&lang=it&arrival=2025-05-19&departure=2025-05-21&guests=[[18,18,6]]
            const url = new URL(ctx.baseUrl);
            const validUrl = url.pathname.match(/prenotazione|book|buchen/);
            if (!validUrl) {
                ctx.newUrl = '';
                return ctx;
            }
            const paths = {
                it: '/it/camere/prenotazione',
                de: '/de/wohnen/buchen',
                en: '/en/rooms/book',
            };
            const language = ctx.data?.language;
            url.pathname = language ? paths[language] : url.pathname;
            url.searchParams.set('arrival', '[date_begin]');
            url.searchParams.set('departure', '[date_end]');
            url.searchParams.set('lang', '[language]');
            const guestsStr = [];
            if (ctx.data.roomsDispo) {
                ctx.data.roomsDispo.forEach(room => {
                    const { adults } = room;
                    let roomGuests = Array(adults).fill(18);
                    if (room.children) {
                        roomGuests = roomGuests.concat(room?.childrenAges);
                    }
                    guestsStr.push(roomGuests);
                });
            }
            url.searchParams.set('guests', guestsStr?.length ? JSON.stringify(guestsStr) : '[[18,18]]');
            ctx.newData.dateBegin = ctx.data.dateBegin?.replace(/\//g, '-');
            ctx.newData.dateEnd = ctx.data.dateEnd?.replace(/\//g, '-');
            ctx.newUrl = url.toString();
            return ctx;
        },
        boot() {
            const container = document.querySelector('#Bs-BookingWidget');
            if (container) {
                const refreshPage = thn.debounce(() => {
                    thn.pageCheck();
                }, 1200);
                thn.observeDom(container, refreshPage, {
                    attributes: true,
                    childList: true,
                    subtree: true,
                });
                thn.shutdown(() => {
                    refreshPage.cancel();
                    thn.stopObserveDom(container, refreshPage);
                });
            }
        },
        priceObserveDom(ctx) {
            const container = document.querySelector('.Bs-OfferSelection');
            if (!refreshPrice) {
                refreshPrice = thn.debounce(() => {
                    ctx.widget.refresh().catch(() => { });
                }, 800);
                thn.bus.on('dataLayer:event.add_to_cart', refreshPrice);
                thn.bus.on('dataLayer:event.view_item', refreshPrice);
                if (container) {
                    thn.observeDom(container, refreshPrice, {
                        attributes: true,
                        childList: true,
                        subtree: true,
                    });
                }
                thn.pageUnload(() => {
                    if (refreshPrice) {
                        refreshPrice.cancel();
                        if (container) {
                            thn.stopObserveDom(container, refreshPrice);
                        }
                        thn.bus.detach('dataLayer:event.add_to_cart', refreshPrice);
                        thn.bus.detach('dataLayer:event.view_item', refreshPrice);
                        refreshPrice = null;
                    }
                });
            }
        },
        priceParseData() {
            // Dates
            const dateBegin = (thn.dataLayerHelper.get('arrival')
                || thn.parseUrlParameter('arrival'))?.replace(/-/g, '/');
            const dateEnd = (thn.dataLayerHelper.get('departure')
                || thn.parseUrlParameter('departure'))?.replace(/-/g, '/');
            if (!dateBegin || !dateEnd) {
                return null;
            }
            const nights = thn.daysBetween(String(dateBegin), String(dateEnd)) ?? 1;
            // Guests, Adults & Children
            const guestsParamStr = String(thn.parseUrlParameter('guests'));
            const guestsUrl = guestsParamStr ? JSON.parse(guestsParamStr) : [];
            const guestsSel = document.querySelector('.Bs-OccupancyInfo:last-of-type')?.textContent?.trim();
            const guestsArray = guestsSel?.match(/\d+/g)?.map(Number) ?? [];
            const adults = guestsArray[0] || guestsUrl[0].filter(value => value >= 18)?.length || 2;
            let children = guestsUrl[0] ? guestsUrl[0].length - (guestsUrl[0].filter(value => value >= 18)?.length || 0) : 0;
            let childrenAges = guestsUrl[0] ? guestsUrl[0].filter(value => value < 18) : [];
            if (guestsArray.length > 1) {
                children = guestsArray.length > 2 ? guestsArray[1] : 1;
                childrenAges = guestsArray.length > 2 ? guestsArray.slice(2) : guestsArray.slice(1);
            }
            else if (guestsArray.length === 1) {
                children = 0;
            }
            const roomsDispo = [{ adults, children, childrenAges }];
            // Prices & Currency || No Rooms
            const pricesEls = Array.from(document.querySelectorAll('.Bs-Item__Price strong'));
            const prices = pricesEls
                .map((price) => thn.parseNumber(price?.textContent))
                .filter((value) => typeof value !== 'undefined');
            const currency = thn.parseCurrency(document.querySelector('.Bs-Item__Price strong')?.textContent);
            const noAvailability = document.querySelector('.Bs-NotBookableItems__Error');
            if (!thn.empty(prices) && currency && nights) {
                return {
                    dateBegin,
                    dateEnd,
                    adults,
                    children,
                    roomsDispo,
                    price: Math.min(...prices) / nights,
                    currency,
                    roomDetails: roomDetailsParseData(adults, children),
                };
            }
            if (noAvailability) {
                return {
                    dateBegin,
                    dateEnd,
                    adults,
                    children,
                    noRooms: true,
                };
            }
            return null;
        },
        bookingParseData() {
            const { dataLayer } = window;
            const bookingData = Array.isArray(dataLayer)
                ? dataLayer.find((item) => item.event === 'purchase')
                : undefined;
            const bookingId = bookingData?.transaction_id;
            if (!bookingId) {
                return {
                    set: false,
                };
            }
            const datesArray = document.querySelector('.Bs-Header')?.textContent?.trim()?.split(/to|al|bis/) ?? [];
            const year = datesArray[1]?.trim().split(' ')[2];
            const dateBegin = translateDate(datesArray[0]?.concat(year), thn.data.language);
            const dateEnd = translateDate(datesArray[1]?.trim(), thn.data.language);
            const price = bookingData?.value;
            const currency = bookingData?.currency;
            const adults = bookingData?.items?.[0]?.adults;
            const children = bookingData?.items?.[0]?.children;
            return {
                bookingId,
                dateBegin,
                dateEnd,
                price,
                currency,
                adults,
                children,
            };
        },
    };
};

export { factory };
